import './_shared/polyfills';
import { MetrikaPlatformProvider } from '@metrika/ui-kit';
import { createBrowserHistory } from 'history';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { RecoilReduxBridge, RecoilDevTools, RecoilTunnel } from 'recoil-toolkit';
import { appEnv, FlagsProvider } from './_env';
import { UFlagProvider } from './_env/unleash';
import { ToastWrapper } from './_shared/components';
import { initSentry } from './_shared/sentry';
import { initStore } from './_shared/store';
import AppLogin from './AppLogin';
import AppRisk from './AppRisk';

const history = createBrowserHistory();
const store = initStore();

initSentry(history);

const serialize = (obj: unknown) => {
   const replacer = (key: string, value: unknown) => {
      if (typeof value === 'object' && value !== null) {
         if (value instanceof HTMLElement) {
            return '[HTMLElement Ref]';
         }
         if ('_reactInternals' in value) {
            return '[React Component Ref]';
         }
         if (Object.keys(value).reduce((acc, key) => acc || key.startsWith('__react'), false)) {
            return '[React Fiber Ref]';
         }
         return value;
      }
      return value;
   };

   return JSON.stringify(obj, replacer);
};

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
   <React.StrictMode>
      <MetrikaPlatformProvider platform="web">
         <UFlagProvider>
            <RecoilRoot>
               <RecoilTunnel />
               {appEnv.flags.debugDevTools && <RecoilDevTools forceSerialize={true} serializer={serialize} />}
               {appEnv.flags.debugDevTools && appEnv.flags.debugDevToolsRedux && <RecoilReduxBridge store={store} />}
               <FlagsProvider>
                  <Provider store={store}>
                     <Router history={history}>
                        {appEnv.isAppLogin ? <AppLogin /> : appEnv.isAppRisk ? <AppRisk /> : null}
                     </Router>
                     <ToastWrapper />
                  </Provider>
               </FlagsProvider>
            </RecoilRoot>
         </UFlagProvider>
      </MetrikaPlatformProvider>
   </React.StrictMode>,
   document.getElementById('root'),
);
